export default function () {
  const badge = document.querySelector('.cart-bar__badge');
  const tierBadge = document.querySelector('[data-tier-badge]');
  const badgeQuantity = parseInt(badge.querySelector('.cart-bar__count').textContent);
  if (!badgeQuantity) {
    badge.classList.remove('cart-bar__badge--active');
  }
  document.addEventListener('scroll', function() {
    if(window.scrollY >= 105) {
      badge.classList.add('cart-bar__badge--sticky');
      if (tierBadge) tierBadge.classList.add('cart-bar__tier-badge--sticky');
    } else {
      badge.classList.remove('cart-bar__badge--sticky');
      if (tierBadge) tierBadge.classList.remove('cart-bar__tier-badge--sticky');
    }
  });

  document.addEventListener('cart:updated', function (event) {
    refreshTierBadge(event.detail);
  });
}

function refreshTierBadge(data) {
  const badge = document.querySelector('[data-tier-badge]');
  if (!badge || !data || !data.discountInfo) return;

  const info = data.discountInfo;

  if (data.itemsCount === 0 || !info.hasTiers || info.amountToNextTier === null) {
    badge.classList.remove('cart-bar__tier-badge--active');
    return;
  }

  const valueEl = badge.querySelector('.cart-bar__tier-badge-value');
  const discountEl = badge.querySelector('.cart-bar__tier-badge-discount');

  if (valueEl) {
    valueEl.textContent = parseFloat(info.amountToNextTier).toLocaleString("en-US", {minimumFractionDigits: 0}) + ' ' + badge.dataset.currency;
  }
  if (discountEl && badge.dataset.tplDiscount) {
    discountEl.textContent = badge.dataset.tplDiscount.replace('__PERCENT__', info.nextTierPercent);
  }

  badge.classList.add('cart-bar__tier-badge--active');
}
